import { NgClass, NgFor, NgIf } from '@angular/common';
import { MaskitoDirective } from '@maskito/angular';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { PainelExpansaoComponent } from '../../shared/painel-expansao/painel-expansao.component';
import { maskitoTransform } from '@maskito/core';
import {
  mask_mes_ano,
  mask_porcentagem_limpa as mask_porcentagem_limpa_p1,
  mask_porcentagem_limpa_duas_casas_decimais,
  mask_dinheiro_limpo,
} from '../../directives/mascaras';
import {
  MemoriaDeCalculoService,
  PQRAdicionaisService,
  PQRAlimentacaoEscolarService,
  PQRCargaHorarioEnsinoService,
  PQREncargosSociaisService,
  PQRFatorPonderacaoService,
  PQRFormacaoJornadaRemuneracaoProfessoresService,
  PQRInfraestruturaPrediosEscolaresService,
  PQRManutencaoFormacaoMaterialService,
  PQRMultiplicadorAnualService,
  PQRNovasSalasPrediosService,
  PQRNumeroDiasLetivosService,
  PQRQuadroFuncionariosRemuneracaoService,
  PQRTamanhoTurmaService,
} from '../../services';
import {
  PQRAdicionaisDto,
  PQRAlimentacaoEscolarDto,
  PQRCargaHorarioEnsinoDto,
  PQREncargosSociaisDto,
  PQRFatorPonderacaoDto,
  PQRFormacaoJornadaRemuneracaoProfessoresDto,
  PQRInfraestruturaPrediosEscolaresDto,
  PQRManutencaoFormacaoMaterialDto,
  PQRMultiplicadorAnualDto,
  PQRNovasSalasPrediosDto,
  PQRNumeroDiasLetivosDto,
  PQRQuadroFuncionariosRemuneracaoDto,
  PQRTamanhoTurmaDto,
  TipoNivelFormacaoDto,
} from '../../dtos';
import { OnlyNumbersDirective } from '../../directives/only-numbers.directive';
import { PtBrNumberDirective } from '../../directives/pt-br-number.directive';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ModalInconsistenciaComponent } from '../../shared/modal-inconsistencia/modal-inconsistencia.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AutenticacaoService } from '../../services/autenticacao/autenticacao.service';
import { Subscription } from 'rxjs';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import { PQRTamanhoMinimoTurmaService } from '../../services/pqr-tamanho-minimo-turma/pqr-tamanho-minimo-turma.service';
import { PQRTamanhoMinimoTurmaDto } from '../../dtos/pqr-tamanho-minimo-turma.dto';

@Component({
  selector: 'app-pqr',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    NgClass,
    FormsModule,
    MatButton,
    MatIconModule,
    MatMenuModule,
    MaskitoDirective,
    TabelaComponent,
    PainelExpansaoComponent,
    OnlyNumbersDirective,
    PtBrNumberDirective
  ],
  templateUrl: './pqr.component.html',
  styleUrl: './pqr.component.scss',
})
export class PqrComponent implements AfterViewInit, OnInit {
  // painelAdicionais agora está dentro de "Docentes: formação e remuneração"
  @ViewChild('painelDiasLetivos') painelDiasLetivos!: PainelExpansaoComponent;
  @ViewChild('painelCargaHoraria') painelCargaHoraria!: PainelExpansaoComponent;
  @ViewChild('painelTamanhoTurmas') painelTamanhoTurmas!: PainelExpansaoComponent;
  @ViewChild('painelJornadaDocente') painelJornadaDocente!: PainelExpansaoComponent;
  @ViewChild('painelEncargosSociais') painelEncargosSociais!: PainelExpansaoComponent;
  @ViewChild('painelNovasConstrucoes') painelNovasConstrucoes!: PainelExpansaoComponent;
  @ViewChild('painelManutencaoEscolas') painelManutencaoEscolas!: PainelExpansaoComponent;
  @ViewChild('painelAlimentacaoEscolar') painelAlimentacaoEscolar!: PainelExpansaoComponent;
  @ViewChild('painelQuadroFuncionarios') painelQuadroFuncionarios!: PainelExpansaoComponent;
  @ViewChild('painelCarreiraProfessores') painelCarreiraProfessores!: PainelExpansaoComponent;
  @ViewChild('painelInfraestruturaEscolar') painelInfraestruturaEscolar!: PainelExpansaoComponent;
  @ViewChild('painelAdicionalRemuneracao') painelAdicionalRemuneracao!: PainelExpansaoComponent;

  paineis: PainelExpansaoComponent[] = [];
  todosOsPaineisEstaoAbertos: boolean = false;
  totalPercentualManutencaoEscolas: string = '';

  pqrNumeroDiasLetivos: PQRNumeroDiasLetivosDto[] = [];
  pqrCargaHoraria: PQRCargaHorarioEnsinoDto[] = [];
  pqrTamanhoTurmas: PQRTamanhoTurmaDto[] = [];
  pqrCarreiraProfessores: PQRFormacaoJornadaRemuneracaoProfessoresDto[] = [];
  pqrAdicionais: PQRAdicionaisDto[] = [];
  pqrFatorPonderacao!: PQRFatorPonderacaoDto;
  pqrQuadroFuncionarios: PQRQuadroFuncionariosRemuneracaoDto[] = [];
  pqrManutencaoEscolas: PQRManutencaoFormacaoMaterialDto[] = [];
  pqrEncargosSociais: PQREncargosSociaisDto[] = [];
  pqrMultiplicadorAnual: PQRMultiplicadorAnualDto[] = [];
  pqrInfraestruturaEscolar: PQRInfraestruturaPrediosEscolaresDto[] = [];
  pqrNovasConstrucoes: PQRNovasSalasPrediosDto[] = [];
  pqrAlimentacaoEscolar: PQRAlimentacaoEscolarDto[] = [];
  pqrTamanhoMinimoTurmas: PQRTamanhoMinimoTurmaDto[] = [];

  get pqrTamanhoTurmasFiltradas(): PQRTamanhoTurmaDto[] {
    const ffAtivas = this.featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma') &&
      this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade');
    if (ffAtivas) {
      // Quando FF true: mostrar creches (10-13) primeiro, não mostrar código 1
      const sortPorEtapaELocalizacao = (a: PQRTamanhoTurmaDto, b: PQRTamanhoTurmaDto) => {
        if (a.etapaEnsino.codEtapaEnsino !== b.etapaEnsino.codEtapaEnsino)
          return a.etapaEnsino.codEtapaEnsino - b.etapaEnsino.codEtapaEnsino;
        return a.tipoLocalizacao.codTipoLocalizacao - b.tipoLocalizacao.codTipoLocalizacao;
      };
      const creches = this.pqrTamanhoTurmas
        .filter(t => t.etapaEnsino.codEtapaEnsino >= 10 && t.etapaEnsino.codEtapaEnsino <= 13)
        .sort(sortPorEtapaELocalizacao);
      const outros = this.pqrTamanhoTurmas
        .filter(t => t.etapaEnsino.codEtapaEnsino !== 1 && (t.etapaEnsino.codEtapaEnsino < 10 || t.etapaEnsino.codEtapaEnsino > 13))
        .sort(sortPorEtapaELocalizacao);
      return [...creches, ...outros];
    } else {
      // Quando FF false: mostrar código 1, não mostrar 10-13
      return this.pqrTamanhoTurmas.filter(t => t.etapaEnsino.codEtapaEnsino < 10 || t.etapaEnsino.codEtapaEnsino > 13);
    }
  }

  mask_dinheiro_limpo = mask_dinheiro_limpo
  mask_porcentagem_limpa = mask_porcentagem_limpa_p1;
  mask_fator_ponderacao = mask_porcentagem_limpa_duas_casas_decimais;
  mask_mes_ano = mask_mes_ano

  ehEdicao = false

  isLogado = false

  opcoesFormacao: TipoNivelFormacaoDto[] = [
    { codTipoNivelFormacao: 1, descricao: 'Médio' },
    { codTipoNivelFormacao: 2, descricao: 'Superior' },
    { codTipoNivelFormacao: 3, descricao: 'Especialização' },
    { codTipoNivelFormacao: 4, descricao: 'Mestrado' },
    { codTipoNivelFormacao: 5, descricao: 'Doutorado' },
  ];

  private logoutSubscription: Subscription = new Subscription();

  constructor(
    private toastr: ToastrService,
    private pqrAdicionaisService: PQRAdicionaisService,
    private pqrTamanhoTurmaService: PQRTamanhoTurmaService,
    private pqrNovasSalasPrediosService: PQRNovasSalasPrediosService,
    private pqrNumeroDiasLetivosService: PQRNumeroDiasLetivosService,
    private pqrCargaHorarioEnsinoService: PQRCargaHorarioEnsinoService,
    private pqrAlimentacaoEscolarService: PQRAlimentacaoEscolarService,
    private pqrQuadroFuncionariosRemuneracaoService: PQRQuadroFuncionariosRemuneracaoService,
    private pqrFormacaoJornadaRemuneracaoProfessoresService: PQRFormacaoJornadaRemuneracaoProfessoresService,
    private pqrInfraestruturaPrediosEscolaresService: PQRInfraestruturaPrediosEscolaresService,
    private pqrManutencaoFormacaoMaterialService: PQRManutencaoFormacaoMaterialService,
    private pqrEncargosSociaisService: PQREncargosSociaisService,
    private pqrMultiplicadorAnualService: PQRMultiplicadorAnualService,
    private pqrFatorPonderacaoService: PQRFatorPonderacaoService,
    private pqrTamanhoMinimoTurmaService: PQRTamanhoMinimoTurmaService,
    private memoriaCalculoService: MemoriaDeCalculoService,
    private dialogInconsistencia: MatDialog,
    private route: ActivatedRoute,
    private autenticacaoService: AutenticacaoService,
    public featureFlagService: FeatureFlagService
  ) { }

  ngAfterViewInit() {
    this.paineis = [
      this.painelDiasLetivos,
      this.painelCargaHoraria,
      this.painelTamanhoTurmas,
      this.painelCarreiraProfessores,
      /*this.painelJornadaDocente,*/ /// TODO: Verificar se é necessário, não está definido esse painel.
      this.painelNovasConstrucoes,
      this.painelQuadroFuncionarios,
      this.painelAlimentacaoEscolar,
      this.painelInfraestruturaEscolar,
      this.painelCarreiraProfessores,
      this.painelAdicionalRemuneracao
    ];

  }

  obterDescricaoItemAdicional(dados: PQRAdicionaisDto): string {
    if (
      dados.descricaoItem === 'Adicional de remuneração para professores das escolas rurais'
    ) {
      return 'Adicional de remuneração para profissionais das escolas do campo';
    }
    return dados.descricaoItem;
  }

  obterDescricaoEtapaCargaHoraria(descricao: string): string {
    return descricao === 'EJA' ? 'Educação de Jovens e Adultos (EJA)' : descricao;
  }

  ngOnInit() {
    this.recarregueValoresOriginais();

    this.autenticacaoService.isLogadoRefreshSeNao().subscribe(is => this.isLogado = is)

    // Adicionar listener para evento de logout
    this.logoutSubscription = this.autenticacaoService.onLogout().subscribe(() => {
      if (this.ehEdicao) {
        this.desabiliteEdicao();
        this.recarregueValoresOriginais();
      }
    });
  }

  recarregueValoresOriginais() {
    // Recarregar todos os dados do servidor
    this.pqrNumeroDiasLetivosService
      .buscarListaDePQRNumeroDiasLetivos()
      .subscribe((data) => this.pqrNumeroDiasLetivos = data);

    this.pqrCargaHorarioEnsinoService
      .buscarListaDePQRCargaHorarioEnsino()
      .subscribe((data) => this.pqrCargaHoraria = data);

    this.pqrTamanhoTurmaService
      .buscarListaDePQRTamanhoTurma()
      .subscribe((data) => this.pqrTamanhoTurmas = data);

    if (this.featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma') &&
      this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade')) {
      this.pqrTamanhoMinimoTurmaService
        .buscarListaDePQRTamanhoMinimoTurma()
        .subscribe((data) => this.pqrTamanhoMinimoTurmas = data);
    }

    this.pqrFormacaoJornadaRemuneracaoProfessoresService
      .buscarListaDePQRFormacaoJornadaRemuneracaoProfessores()
      .subscribe((data) => this.pqrCarreiraProfessores = data);

    this.pqrAdicionaisService
      .buscarListaDePQRAdicionais()
      .subscribe((data) => this.pqrAdicionais = data);

    this.pqrQuadroFuncionariosRemuneracaoService
      .buscarListaDePQRQuadroFuncionariosRemuneracao()
      .subscribe((data) => this.pqrQuadroFuncionarios = data);

    this.pqrInfraestruturaPrediosEscolaresService
      .buscarListaDePQRInfraestruturaPrediosEscolares()
      .subscribe((data) => this.pqrInfraestruturaEscolar = data);

    this.pqrNovasSalasPrediosService
      .buscarListaDePQRNovasSalasPredios()
      .subscribe((data) => this.pqrNovasConstrucoes = data);

    this.pqrAlimentacaoEscolarService
      .buscarListaDePQRAlimentacaoEscolar()
      .subscribe((data) => this.pqrAlimentacaoEscolar = data);

    this.pqrManutencaoFormacaoMaterialService
      .buscarListaDePQRManutencaoFormacaoMaterial()
      .subscribe((data) => {
        this.pqrManutencaoEscolas = data;
        this.calcularTotalPercentualManutencaoEscolas();
      });

    this.pqrEncargosSociaisService
      .buscarListaDePQREncargosSociais()
      .subscribe((data) => this.pqrEncargosSociais = data);

    this.pqrMultiplicadorAnualService
      .buscarListaDePQRMultiplicadorAnual()
      .subscribe((data) => this.pqrMultiplicadorAnual = data);

    this.pqrFatorPonderacaoService
      .buscarPQRFatorPonderacao()
      .subscribe((data) => this.pqrFatorPonderacao = data);
  }

  ngOnDestroy() {
    if (this.logoutSubscription) {
      this.logoutSubscription.unsubscribe();
    }
  }

  calcularTotalPercentualManutencaoEscolas(): void {
    let total = 0;
    this.pqrManutencaoEscolas.forEach((despesa) => {
      total += Number(String(despesa.percentual).split(',').join('.'));
    });

    this.totalPercentualManutencaoEscolas = maskitoTransform(String(total), this.mask_porcentagem_limpa);
  }

  public transformarValorParaPorcentagem(valor: number): string {
    return maskitoTransform(String(valor), this.mask_porcentagem_limpa);
  }

  public transformarValorParaData(valor: string): string {
    const splitedDate = valor.split('-')
    const adjustedDateString = `${splitedDate[1]}${splitedDate[0]}`
    return maskitoTransform(adjustedDateString, this.mask_mes_ano);
  }

  public transformarValorParaDataCarreiraRemuneracao(valor: string): string {
    const splitedDate = valor.split('-')
    const adjustedDateString = `${splitedDate[0]}${splitedDate[1]}`
    return maskitoTransform(adjustedDateString, this.mask_mes_ano);
  }

  public openAllPanels() {
    this.paineis.forEach((painel) => painel.abrirPainel());
    this.todosOsPaineisEstaoAbertos = true;
  }

  public closeAllPanels() {
    this.paineis.forEach((painel) => painel.fecharPainel());
    this.todosOsPaineisEstaoAbertos = false;
  }

  public habiliteEdicao() {
    this.ehEdicao = true;
    this.openAllPanels();
  }

  public desabiliteEdicao() {
    this.ehEdicao = false;
    this.closeAllPanels();
  }

  salvePQRNumeroDiasLetivos() {
    const inconsistencias = this.obtenhaInconsistenciasNumeroDiasLetivos();

    if (inconsistencias.length == 0) {
      this.pqrNumeroDiasLetivos.forEach(pqr => {
        this.pqrNumeroDiasLetivosService.salveListaDePQRNumeroDiasLetivos(pqr);
      });
      this.exibaToastSucesso('Número de dias letivos');
      return;
    }

    this.exibirDialogInconsistencia(inconsistencias, () => {
      this.pqrNumeroDiasLetivos.forEach(pqr => {
        this.pqrNumeroDiasLetivosService.salveListaDePQRNumeroDiasLetivos(pqr);
      });
      this.exibaToastSucesso('Número de dias letivos');
    });
  }

  salvePQRCargaHorariaEnsino() {
    const inconsistencias = this.obtenhaInconsistenciasCargaHorariaEnsino();
    if (inconsistencias.length == 0) {
      this.pqrCargaHoraria.forEach(pqr => {
        this.pqrCargaHorarioEnsinoService.salvePQRCargaHorariaEnsino(pqr);
      });
      this.exibaToastSucesso('Carga horária de ensino');
      return;
    }

    this.exibirDialogInconsistencia(inconsistencias, () => {
      this.pqrCargaHoraria.forEach(pqr => {
        this.pqrCargaHorarioEnsinoService.salvePQRCargaHorariaEnsino(pqr);
      });
      this.exibaToastSucesso('Carga horária de ensino');
    });
  }

  salvePQRTamanhoTurma() {
    this.pqrTamanhoTurmas.forEach(pqr => {
      this.pqrTamanhoTurmaService.salvePQRTamanhoTurma(pqr);
    });

    if (this.featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma') &&
      this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade')) {
      this.pqrTamanhoMinimoTurmas.forEach(pqr => {
        this.pqrTamanhoMinimoTurmaService.salvePQRTamanhoMinimoTurma(pqr);
      });
    }

    this.exibaToastSucesso('Tamanho das turmas');
  }

  salvePQRJornadaTrabalhoDocente() {
    //
  }

  salvePQRCarreiraRemuneracaoProfessores() {
    const inconsistencias = this.obtenhaInconsistenciasCarreiraRemuneracaoProfessores();
    if (inconsistencias.length == 0) {
      this.pqrCarreiraProfessores.forEach(pqr => {
        const nivelFormacaoSelecionada: TipoNivelFormacaoDto | undefined = this.opcoesFormacao.find(op => op.codTipoNivelFormacao == pqr.tipoNivelFormacao.codTipoNivelFormacao);
        if (nivelFormacaoSelecionada) {
          pqr.tipoNivelFormacao = nivelFormacaoSelecionada;
        }

        pqr.jornadaComInteracao = this.convertaPorcentagemParaNumero(pqr.jornadaComInteracao.toString());
        pqr.jornadaSemInteracao = this.convertaPorcentagemParaNumero(pqr.jornadaSemInteracao.toString());
        pqr.remuneracaoBrutaMensal = this.convertaValorMonetarioParaNumero(pqr.remuneracaoBrutaMensal.toString());
        this.pqrFormacaoJornadaRemuneracaoProfessoresService.salvePQRFormacaoJornadaRemuneracaoProfessores(pqr);
      });

      this.exibaToastSucesso('Docentes: formação e remuneração');
      return;
    }

    this.exibirDialogInconsistencia(inconsistencias, () => {
      this.pqrCarreiraProfessores.forEach(pqr => {
        const nivelFormacaoSelecionada: TipoNivelFormacaoDto | undefined = this.opcoesFormacao.find(op => op.codTipoNivelFormacao == pqr.tipoNivelFormacao.codTipoNivelFormacao);
        if (nivelFormacaoSelecionada) {
          pqr.tipoNivelFormacao = nivelFormacaoSelecionada;
        }

        pqr.jornadaComInteracao = this.convertaPorcentagemParaNumero(pqr.jornadaComInteracao.toString());
        pqr.jornadaSemInteracao = this.convertaPorcentagemParaNumero(pqr.jornadaSemInteracao.toString());
        pqr.remuneracaoBrutaMensal = this.convertaValorMonetarioParaNumero(pqr.remuneracaoBrutaMensal.toString());
        this.pqrFormacaoJornadaRemuneracaoProfessoresService.salvePQRFormacaoJornadaRemuneracaoProfessores(pqr);
      });

      this.exibaToastSucesso('Docentes: formação e remuneração');
    });
  }

  salvePQRAdicionais() {
    this.pqrAdicionais.forEach(pqr => {
      pqr.percentual = this.convertaPorcentagemParaNumero(pqr.percentual.toString());
      this.pqrAdicionaisService.salvePQRAdicionais(pqr);
    });

    this.exibaToastSucesso('Adicionais');
  }

  salvePQRFatorPonderacao() {
    this.pqrFatorPonderacaoService.salvePQRFatorPonderacao(this.pqrFatorPonderacao);
    this.exibaToastSucesso('Fator de Ponderação');
  }

  salvePQRQuadroRemuneracao() {
    this.pqrQuadroFuncionarios.forEach(pqr => {
      const nivelFormacaoSelecionada: TipoNivelFormacaoDto | undefined = this.opcoesFormacao.find(op => op.codTipoNivelFormacao == pqr.tipoNivelFormacao.codTipoNivelFormacao);
      if (nivelFormacaoSelecionada) {
        pqr.tipoNivelFormacao = nivelFormacaoSelecionada;
      }
      pqr.remuneracaoBrutaMensal = this.convertaValorMonetarioParaNumero(pqr.remuneracaoBrutaMensal.toString());
      this.pqrQuadroFuncionariosRemuneracaoService.salvePQRQuadroRemuneracao(pqr);
    });

    this.exibaToastSucesso('Quadro de funcionário e remuneração');
  }

  salvePQRAlimentacaoEscolar() {
    this.pqrAlimentacaoEscolar.forEach(pqr => {
      pqr.valorRefeicao = this.convertaValorMonetarioParaNumero(pqr.valorRefeicao.toString());
      pqr.valorRefeicaoIndigenaQuilombola = this.convertaValorMonetarioParaNumero(pqr.valorRefeicaoIndigenaQuilombola.toString())
      this.pqrAlimentacaoEscolarService.salvePQRAlimentacaoEscolar(pqr)
    });

    this.exibaToastSucesso('Alimentação escolar');
  }

  salvePQREncargosSociais() {
    const inconsistencias = this.obtenhaInconsistenciasEncargosSociais();
    if (inconsistencias.length == 0) {
      this.pqrEncargosSociais.forEach(pqr => {
        pqr.percentual = this.convertaPorcentagemParaNumero(pqr.percentual.toString());
        this.pqrEncargosSociaisService.salvePQREncargosSociais(pqr);
      });
      this.pqrMultiplicadorAnual.forEach(pqr => {
        pqr.multiplicadorAnual = this.convertaPorcentagemParaNumero(pqr.multiplicadorAnual.toString());
        this.pqrMultiplicadorAnualService.salvePQRMultiplicadorAnual(pqr);
      });
      this.exibaToastSucesso('Direitos e obrigações trabalhistas');
      return;
    }

    this.exibirDialogInconsistencia(inconsistencias, () => {
      this.pqrEncargosSociais.forEach(pqr => {
        pqr.percentual = this.convertaPorcentagemParaNumero(pqr.percentual.toString());
        this.pqrEncargosSociaisService.salvePQREncargosSociais(pqr);
      });
      this.pqrMultiplicadorAnual.forEach(pqr => {
        pqr.multiplicadorAnual = this.convertaPorcentagemParaNumero(pqr.multiplicadorAnual.toString());
        this.pqrMultiplicadorAnualService.salvePQRMultiplicadorAnual(pqr);
      });
      this.exibaToastSucesso('Direitos e obrigações trabalhistas');
    });
  }

  atualizeDataPQRAlimentacaoEscolar(event: any) {
    const pqrAlvo = this.pqrAlimentacaoEscolar.find(pqr => pqr.codPqrAlimentacaoEscolar == event.target?.id);
    this.atualizeValorMesAnoRef(pqrAlvo, event);
  }

  atualizeDataPQRCarreiraProfessor(event: any) {
    const pqrAlvo = this.pqrCarreiraProfessores.find(pqr => pqr.codPqrFormacaoJornadaRemuneracaoProfessores == event.target?.id);
    this.atualizeValorMesAnoRef(pqrAlvo, event);
  }

  atualizeDataPQRQuadroFuncionario(event: any) {
    const pqrAlvo = this.pqrQuadroFuncionarios.find(pqr => pqr.codPqrQuadroFuncionariosRemuneracao == event.target?.id);
    this.atualizeValorMesAnoRef(pqrAlvo, event);
  }

  atualizeValorMesAnoRef(pqrAlvo: any, event: any) {
    if (pqrAlvo) {
      const data = event.target.value.split('/');
      pqrAlvo.mesAnoReferencia = `${data[1]}-${data[0]}-01`;
    }
  }

  exibaToastSucesso(nomePQR: string): void {
    this.toastr.success(`PQR de ${nomePQR} editado com sucesso.`, 'Sucesso!');
  }

  convertaValorMonetarioParaNumero(valor: string): number {
    let valorFormatado = valor.replace(/\s/g, '')
      .replace('R$', '')

    if (valorFormatado.includes(',')) {
      valorFormatado = valorFormatado.replace(/\./g, '').replace(',', '.')
    }

    return Number(valorFormatado);
  }

  convertaPorcentagemParaNumero(valor: string): number {
    const valorFormatado = valor.replace(/\s/g, '')
      .replace('%', '')
      .replace(',', '.')

    return Number(valorFormatado);
  }

  obtenhaInconsistenciasNumeroDiasLetivos(): string[] {
    const mensagens: string[] = [];
    this.pqrNumeroDiasLetivos.forEach((valor: PQRNumeroDiasLetivosDto) => {
      if (valor.qntDiasLetivos < 1 || valor.qntDiasLetivos > 7) {
        mensagens.push(`O número de dias letivos por semana da etapa ${valor.etapaEnsino.descricao} não é válido.Informe um valor de 1 a 7 dias.`);
      }
    });

    return mensagens;
  }

  obtenhaInconsistenciasCargaHorariaEnsino(): string[] {
    const mensagens: string[] = [];
    this.pqrCargaHoraria.forEach((valor: PQRCargaHorarioEnsinoDto) => {
      if (valor.qntCargaHorariaDiaria < 3 || valor.qntCargaHorariaDiaria > 12) {
        mensagens.push(`Carga horária diária na etapa ${valor.etapaEnsino.descricao} no turno ${valor.tipoTurno.descricao} não é válido.Informe um valor de 3 a 12.`);
      }
    });

    return mensagens;
  }

  obtenhaInconsistenciasCarreiraRemuneracaoProfessores(): string[] {
    const mensagens: string[] = [];
    this.pqrCarreiraProfessores.forEach((valor: PQRFormacaoJornadaRemuneracaoProfessoresDto) => {
      if (this.convertaValorMonetarioParaNumero(valor.remuneracaoBrutaMensal.toString()) <= 0) {
        mensagens.push(`A remuneração bruta mensal da seqûencia ${valor.denominacao} deve ser um valor maior que 0.`);
      }
    });

    return mensagens;
  }

  obtenhaInconsistenciasEncargosSociais(): string[] {
    const mensagens: string[] = [];
    this.pqrEncargosSociais.forEach((valor: PQREncargosSociaisDto) => {
      if (valor.percentual < 0 || valor.percentual > 100) {
        mensagens.push(`O valor do percentual do item Direitos e obrigações trabalhista não é válido.Informe um valor de 0% a 100%.`);
      }
    });

    return mensagens;
  }

  exibirDialogInconsistencia(mensagemInconsistencia: string[], aoClicarEmSim: () => void): void {
    this.toastr.error('Verifique as inconsistências.', 'Atenção!');

    const data = {
      mensagens: mensagemInconsistencia
    };

    const dialogRef = this.dialogInconsistencia.open(ModalInconsistenciaComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'sim') {
        aoClicarEmSim();
      }
    });
  }

  solicitarRecalculoMemoriaCalculo() {
    this.memoriaCalculoService.recalcularMemoriaDeCalculoComNovosPqrs().
      then((memoriaDeCalculoDto) => {
        this.toastr.success('Memória de cálculo recalculada com sucesso.', 'Sucesso!');
      }).catch((error) => {
        this.toastr.error('Erro ao recalcular a memória de cálculo.', 'Erro!');
      });
  }

  adicionarDespesa(): void {
    this.pqrManutencaoEscolas.push({
      id: this.pqrManutencaoEscolas.length + 1,
      descricaoItem: '',
      percentual: 0
    });
  }

  idsRemovidos: number[] = [];

  removerDespesa(index: number): void {
    const item = this.pqrManutencaoEscolas[index];

    if (item.codPqrAdicionaisManutencaoEncargos) {
      this.idsRemovidos.push(item.codPqrAdicionaisManutencaoEncargos);
    }

    this.pqrManutencaoEscolas.splice(index, 1);
    this.calcularTotalPercentualManutencaoEscolas();
  }

  async salvePQRManutencaoEscolas(): Promise<void> {
    const itens = this.pqrManutencaoEscolas.map(pqr => ({
      ...pqr,
      idTipoCategoriaItem: 2,
      percentual: this.convertaPorcentagemParaNumero(pqr.percentual.toString()),
    }));

    await this.pqrManutencaoFormacaoMaterialService
      .salvarTodosPQRManutencaoEscolas(itens, this.idsRemovidos);

    this.idsRemovidos = [];
    this.calcularTotalPercentualManutencaoEscolas();
    this.exibaToastSucesso('Serviços, infraestrutura e recursos');
  }

  garantirMinimo(campo: keyof PQRFatorPonderacaoDto): void {
    const valorBruto = this.pqrFatorPonderacao[campo];

    const valorLimpo = Number(
      String(valorBruto).replace(/[^\d,]/g, '').replace(',', '.')
    );

    if (!valorLimpo || valorLimpo < 1) {
      this.pqrFatorPonderacao[campo] = 1;
    }
  }
}
